import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { trackEvent } from "@/lib/api";
import Landing from "@/pages/Landing";
import Tool from "@/pages/Tool";
import Login from "@/pages/Login";
import Resume from "@/pages/Resume";
import Affiliate from "@/pages/Affiliate";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Disclaimer from "@/pages/Disclaimer";
import Refund from "@/pages/Refund";
import GetPlaybook from "@/pages/GetPlaybook";
import Dashboard from "@/pages/Dashboard";
import DashboardHome from "@/pages/dashboard/Home";
import DashboardJobs from "@/pages/dashboard/Jobs";
import DashboardMatch from "@/pages/dashboard/Match";
import DashboardReadiness from "@/pages/dashboard/Readiness";
import DashboardProfile from "@/pages/dashboard/Profile";
import DashboardBilling from "@/pages/dashboard/Billing";
import DashboardToolEmbed from "@/pages/dashboard/ToolEmbed";
import DashboardRoleFit from "@/pages/dashboard/RoleFit";
import DashboardPlaybooks from "@/pages/dashboard/Playbooks";
import DashboardToolbox from "@/pages/dashboard/Toolbox";
import DashboardSaved from "@/pages/dashboard/Saved";
import DashboardAlerts from "@/pages/dashboard/Alerts";
import DashboardApplications from "@/pages/dashboard/Applications";
import { PaidRoute } from "@/components/dashboard/index";

function App() {
  // Global delegated listener for `upgrade.click` — fires whenever any anchor
  // pointing at the Whop checkout is clicked, regardless of which surface it
  // lives on (hero CTA, sidebar unlock, mid-page CTA, final CTA, plans).
  useEffect(() => {
    function onClick(e) {
      const a = e.target?.closest?.("a[href]");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (!/whop\.com\/checkout/i.test(href)) return;
      trackEvent("upgrade.click", {
        href,
        cta: a.getAttribute("data-testid") || a.textContent?.trim().slice(0, 40) || null,
      });
    }
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/affiliate" element={<Affiliate />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/get/playbook" element={<GetPlaybook />} />
          <Route path="/dashboard" element={<Dashboard />}>
            <Route index element={<DashboardHome />} />
            <Route path="jobs" element={<DashboardJobs />} />
            <Route path="match" element={<DashboardMatch />} />
            <Route path="rolefit" element={<DashboardRoleFit />} />
            <Route
              path="career-path"
              element={
                <PaidRoute tool="Career Path">
                  <DashboardRoleFit careerPath />
                </PaidRoute>
              }
            />
            <Route path="playbooks" element={<DashboardPlaybooks />} />
            <Route path="toolbox" element={<DashboardToolbox />} />
            <Route path="saved" element={<DashboardSaved />} />
            <Route path="alerts" element={<DashboardAlerts />} />
            <Route path="applications" element={<DashboardApplications />} />
            <Route
              path="readiness"
              element={
                <PaidRoute tool="Job Readiness">
                  <DashboardReadiness />
                </PaidRoute>
              }
            />
            <Route path="profile" element={<DashboardProfile />} />
            <Route path="billing" element={<DashboardBilling />} />
            <Route path="embed/:slug" element={<DashboardToolEmbed />} />
          </Route>
          <Route path="/:slug" element={<Tool />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
